import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Marker } from "google-maps-react";

class Markers extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const google = this.props.google;
    let iw = 17,
      ih = 4.39 * iw;

    return this.props.restaurantData.map(restaurant => {
      return (
        <Marker
          key={restaurant.id}
          ref={this.props.onMarkerMounted}
          restaurant={restaurant}
          position={{ lat: restaurant.latitude, lng: restaurant.longitude }}
          id={restaurant.id}
          onClick={this.props.onMarkerClick}
          onMouseover={this.props.mouseEnterHandler}
          onMouseout={this.props.mouseLeaveHandler}
          {...this.props}
          icon={{
            url: this.props.url,
            anchor: new google.maps.Point(-iw / 4 - 3, ih / 2),
            size: new google.maps.Size(iw, ih),
            scaledSize: new google.maps.Size(iw, ih)
          }}
        />
      );
    });
  }
}
const mapStateToProps = state => {
  return {
    stats: state.stats
  };
};

export default connect(
  mapStateToProps,
  null
)(Markers);
